export const getProductId = (value: string): string => `000000${value}`.slice(-6);
